// extracted by mini-css-extract-plugin
export default {"cargo-image":"imagesplash_cargo-image__xrsbB","cargo-image2":"imagesplash_cargo-image2__jK893"};